import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { reducers } from '../store';
import { provideEffects } from '@ngrx/effects';
import { provideRouterStore } from '@ngrx/router-store';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AuthEffect } from '../store/auth/effects.auth';
import { BaseEffect } from '../store/base/effects.base';
import Aura from '@primeuix/themes/aura';
import { loaderInterceptor } from './core/components/loader/loader.interceptor';
import { MessageService, ConfirmationService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { jwtInterceptor } from './core/auth/guards/jwt.interceptor';
import { DatePipe } from '@angular/common';
import { apiErrorInterceptor } from './core/auth/guards/toasr.interceptor';
import { driverApiTrackingInterceptor } from './core/auth/guards/driver-api-tracking.interceptor';
import {
  MsalService,
  MSAL_INSTANCE,
  MsalGuard,
  MsalBroadcastService,
} from '@azure/msal-angular';

import {
  GoogleLoginProvider,
  SocialLoginModule,
} from '@abacritt/angularx-social-login';
import { PublicClientApplication } from '@azure/msal-browser';
import { ProviderEnvConfigService } from '@gozetta/dispatch-portal';
import { environment } from 'src/environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    ProviderEnvConfigService({
      env: environment.environmentType,
      apiUrl: environment.dispatchUrl,
      ridesCollection: environment.dispatchRidesCollection,
      emergenciesCollection: '',
      adrAdminUrl: environment.dispatchAdrAdminUrl,
      production: environment.dispatchProduction,
      partnerCollection: environment.dispatchPartnerCollection,
      mapDetailsCollection: environment.dispatchMapDetailsCollection,
      conversationsCollection: environment.dispatchConversationsCollection,
      isRunAsLibrary: true,
      isLocal: environment.isLocal,
      rideMapZoomLevel: environment.rideMapZoomLevel,
      cameraStatusesCollection: environment.cameraStatusesCollection,
    }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideStore(reducers),
    provideEffects(AuthEffect, BaseEffect),
    provideStoreDevtools({
      maxAge: 4,
      logOnly: true,
      autoPause: true,
      trace: false,
      traceLimit: 75,
    }),
    provideRouterStore(),
    provideHttpClient(
      withInterceptors([
        loaderInterceptor,
        jwtInterceptor,
        apiErrorInterceptor,
        driverApiTrackingInterceptor, // Add driver API tracking interceptor
      ]),
    ),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '.dark-mode',
          cssLayer: {
            name: 'primeng',
            order: 'normalize, customprimeflex, primeng, customPrimeng',
          },
        },
      },
    }),
    provideHttpClient(),
    MessageService,
    ConfirmationService,
    DatePipe,
    MsalService,
    MsalBroadcastService,
    MsalGuard,
    SocialLoginModule,
    {
      provide: MSAL_INSTANCE,
      useFactory: () => {
        const msalConfig = {
          auth: {
            clientId: '1e22acd3-bff2-4d04-89b8-cc5349a92979',
            authority: 'https://login.microsoftonline.com/common',
            redirect_uri: environment.redirectUri,
          },
        };

        // Create and return the PublicClientApplication instance
        return new PublicClientApplication(msalConfig);
      },
    },
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        lang: 'en',
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              '783896173032-21kqrb7703du55k95sfg963pvt12uism.apps.googleusercontent.com',
            ),
            redirect_uri: environment.redirectUri,
          },
        ],
      },
    },
  ],
};
